interface Provider {
  id: string;
}

export function sortProvidersByReference(reference = [], items: Provider[]) {
  const indexMap = new Map();
  reference.forEach((element, idx) => {
    indexMap.set(element, idx);
  });

  return items.slice().sort((a, b) => {
    const aIndex = indexMap.get(a.id);
    const bIndex = indexMap.get(b.id);

    if (aIndex !== undefined && bIndex !== undefined) {
      return aIndex - bIndex;
    }
    if (aIndex !== undefined && bIndex === undefined) {
      return -1;
    }
    if (aIndex === undefined && bIndex !== undefined) {
      return 1;
    }

    return 0;
  });
}
